exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-purple[data-v-2fa32404]{\r\n    background-color: purple;\n}\n.size-tabela[data-v-2fa32404]{\r\n    width: 700px;\n}\r\n\r\n", ""]);

// exports
